import Vue from 'vue'
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);
let lang = navigator.language.split('-')[0];
if (!['en', 'vi'].includes(lang)) {
    lang = 'en';
}

if (localStorage.getItem('langStorage')) {
    lang = localStorage.getItem('langStorage');
}

export default new VueI18n({
    locale: lang,
    fallbackLocale: 'en',
    silentFallbackWarn: true,
    messages: {
        en: {
            aiMaxConcurrent: 'Concurrent AI auto-calls',
            aiMaxConcurrentPlaceholder: 'Leave blank = 5. Capped by the number of outbound numbers.',
            keyword: 'Enter keywords...',
            search: 'Search',
            create: 'Create new',
            edit: 'Edit',
            update: 'Update',
            delete: 'Delete',
            select: 'Select',
            deleteConfirm: 'Are you sure to delete?',
            deleteAlert: 'Once deleted, you will not be able to recover!',
            success: 'Success',
            error: 'Error',
            warning: 'Warning',
            created: 'Successfully created',
            updated: 'Successfully updated',
            deleted: 'Successfully deleted',
            createFailed: 'Failed to create, please try again',
            updateFailed: 'Failed to update, please try again',
            deleteFailed: 'Failed to delete, please try again',
            contentTooLong: 'Content is too long, please shorten it and try again',
            found: '{0} result(s) found',
            results: 'results',
            notFoundCreate: 'Not found any result, try to create one',
            notFoundSearch: 'Not found any result, try to change your search condition',
            notUpdated: 'Not updated',
            name: 'Name',
            username: 'Username',
            email: 'Email address',
            phone: 'Phone number',
            password: 'Password',
            desc: 'Description',
            userInfo: 'User info',
            status: 'Status',
            activated: 'Activated',
            deactivated: 'Deactivated',
            ip: 'IP Address',
            phoneNumber: 'Phone number',
            client: 'Client',
            phoneHost: 'Phone Host',
            inbound: 'Inbound call',
            outbound: 'Outbound call',
            gateway: 'Gateway',
            role: 'Role',
            owner: 'Owner',
            admin: 'Administrator',
            viewer: 'Viewer',
            sales: 'Sales',
            businessDevelopment: "Sales",
            accountManagement: 'Supporter',
            am: 'Supporter',
            accountant: 'Accountant',
            agent: 'Agent',
            country: 'Country',
            network: 'Network',
            domain: 'Domain',
            today: "Today",
            yesterday: "Yesterday",
            last7Days: "Last 7 days",
            last30Days: "Last 30 days",
            thisWeek: "This week",
            lastWeek: "Last week",
            thisMonth: "This month",
            lastMonth: "Last month",
            anytime: "Anytime",
            time: 'Time',
            all: "All",
            local: 'Local',
            finance: 'Finance',
            mobile: "Phone",
            cancel: "Cancel",
            export: "Export data",
            total: "Total",
            average: "Average",
            group: "Group",
            department: "Department",
            supervisor: "Supervisor",
            manager: "Manager",
            operationsManager: "Operations manager",
            employee: "Employee",
            account: "Account",
            chooseMonth: 'Choose month',
            selectAdminUser: 'Select admin user',
            detail: 'Detail',
            createTime: 'Create time',
            updateTime: 'Update time',
            ext: 'Ext',
            clientPackage: 'Client package',
            creditBalance: 'Credit balance',
            creditLimit: 'Credit limit',
            note: 'Note',
            expireTime: 'Expire time',
            activate: "Activate",
            lock: "Lock",
            type: "Type",
            isPackage: "Package",
            yes: "Yes",
            no: "No",
            agency: "Agency",
            chooseAgency: "Choose agency",
            companyName: "Company name",
            businessCategory: "Business category",
            unknown: "Unknown",
            exportingData: "Exporting data...",
            chooseBusinessCategory: "Choose business Category",
            category0: "Other",
            category1: "Insurance",
            category2: "Real estate",
            category3: "Distributing, Retailing, Online selling, E-commerce",
            category4: "Finance (Banking, Personal finance, Stock)",
            category5: "Tax, Accounting consulting, Digital signatures",
            category6: "Technology system integrating, Other software",
            category7: "Spa, Beauty salon",
            category8: "Medical, Hospital, Clinic, Healthcare",
            category9: "Education, Vocational Training Center, English Center, Study Abroad Counseling",
            clientTrialExtendRequest: "Client trial extend request",
            requestedBy: "Requested by",
            request: "Request",
            waiting: "Waiting",
            approved: "Approved",
            rejected: "Rejected",
            approve: "Approve",
            reject: "Reject",
            approveTime: "Approve time",
            rejectTime: "Reject time",
            approvedBy: "Approved by",
            rejectedBy: "Rejected by",
            user: "User",
            inboundEnabled: "Inbound enabled",
            inboundDisabled: "Inbound disabled",
            outboundEnabled: "Outbound enabled",
            outboundDisabled: "Outbound disabled",
            audioCallPrice: "Audio call price / minute",
            videoCallPrice: "Video call price / minute",
            customerPrice: "Customer price",
            opportunityPrice: "Opportunity price",
            ticketPrice: "Ticket price",
            campaignContactPrice: "Campaign contact price",
            price: "Price",
            unlimitedUser: "Unlimited number of user",
            noExpireTime: "No expire time",
            undefined: 'Undefined',
            info: 'Information',
            save: 'Save',
            isTrial: 'Is trial',
            exportNotice: 'Data is being exported. Please wait for a few moment...',
            notVerified: 'Not verified',
            verified: 'Verified',
            locked: 'Locked',
            other: "Other",
            more: "More",
            selectClient: 'Select Client',
            sendTime: "Send time",
            messageCampaigns: "Message campaigns",
            template: "Message template",
            sendErrorMsg: "Error mesage",
            notYetSent: "Not yet sent",
            sent: "Sent",
            sentFail: "Sent failed",
            kycRequest: {
                title: 'KYC Request',
                create: 'Create KYC request',
                createdSuccess: 'Request created — Account has been notified via Slack',
                kycSubmitted: 'KYC submitted',
                kycMissing: 'Customer has NOT submitted KYC',
                kycMissingNote: 'Customer has already seen the KYC notification in callio-client. Wait for them to submit — status will auto-update.',
                alreadyHasPending: 'There is already an in-progress request',
                priorWarnTitle: 'This customer already had a KYC request before',
                priorConfirm: 'This customer already had a KYC request before. Create a new one anyway?',
                openExisting: 'Open existing request',
                warnNoDefaultAccount: 'No default Account assigned to this Client. Please select someone to handle.',
                alreadyTaken: 'Request has already been taken by another user',
                cannotCancelTerminal: 'Cannot cancel — request already finalized',
                cannotEditTerminal: 'Cannot edit — request already finalized',
                cannotReassignTerminal: 'Cannot reassign — request already finalized',
                invalidTransition: 'Invalid status transition',
                kycNotFound: 'Customer has not submitted KYC yet — cannot sync',
                clientLabel: 'Client',
                noFilter: 'No filter',
                myRequests: 'My requests',
                stale: 'Over 7 days',
                staleAlert: '{n} requests not handled for over 7 days',
                summary: 'Summary',
                status: {
                    pending: 'New',
                    waitingKyc: 'Waiting KYC',
                    kycSubmitted: 'KYC submitted',
                    inReview: 'Reviewing',
                    exported: 'Contract exported',
                    canceled: 'Canceled',
                    all: 'All',
                },
                contractType: {
                    unspecified: 'Unspecified',
                    new: 'New contract',
                    renewal: 'Renewal',
                    upgrade: 'Upgrade plan',
                    changeEntity: 'Change entity',
                    other: 'Other',
                },
                priority: {
                    normal: 'Normal',
                    high: 'High',
                    urgent: 'Urgent',
                },
                action: {
                    take: 'Take',
                    reassign: 'Reassign',
                    startReview: 'Start review',
                    exportContract: 'Export contract',
                    syncKyc: 'Sync KYC manually',
                    cancel: 'Cancel',
                    viewExistingKyc: 'View customer KYC',
                    backToList: 'Back to list',
                },
                field: {
                    contractType: 'Contract type',
                    priority: 'Priority',
                    assignedTo: 'Account handling',
                    requestedBy: 'Sales requesting',
                    note: 'Note',
                    cancelReason: 'Cancel reason',
                    contractNumber: 'Contract number',
                    createTime: 'Created at',
                    updateTime: 'Updated at',
                    exportTime: 'Export time',
                },
                section: {
                    info: 'Request info',
                    kycStatus: 'Customer KYC status',
                    contract: 'Contract',
                    history: 'History',
                },
                history: {
                    bySystem: '(system)',
                },
            },
        },
        vi: {
            aiMaxConcurrent: 'Số cuộc gọi tự động bằng AI chạy cùng lúc',
            aiMaxConcurrentPlaceholder: 'Bỏ trống = 5. Trần thật còn bị chặn bởi số lượng số gọi ra.',
            keyword: 'Từ khóa...',
            search: 'Tìm kiếm',
            create: 'Thêm mới',
            edit: 'Sửa',
            update: 'Cập nhật',
            delete: 'Xóa',
            select: 'Chọn',
            deleteConfirm: 'Bạn chắc chắn muốn xóa chứ?',
            deleteAlert: 'Sẽ không thể khôi phục lại dữ liệu đã xóa!',
            success: 'Thành công',
            error: 'Có lỗi',
            warning: 'Cảnh báo',
            created: 'Thêm mới thành công',
            updated: 'Cập nhật thành công',
            deleted: 'Xóa thành công',
            createFailed: 'Thêm mới thất bại, mời bạn thử lại lần sau',
            updateFailed: 'Cập nhật thất bại, mời bạn thử lại lần sau',
            deleteFailed: 'Xóa thất bại, mời bạn thử lại lần sau',
            contentTooLong: 'Nội dung quá dài, vui lòng rút gọn rồi thử lại',
            found: 'Tìm thấy {0} kết quả',
            results: 'kết quả',
            notFoundCreate: 'Không tìm thấy kết quả nào, mời bạn tạo mới để bắt đầu sử dụng',
            notFoundSearch: 'Không tìm thấy kết quả nào, thay đổi điều kiện tìm kiếm để thử lại',
            notUpdated: 'Chưa cập nhật',
            name: 'Tên',
            username: 'Tên đăng nhập',
            email: 'Địa chỉ email',
            phone: 'Số điện thoại',
            password: 'Mật khẩu',
            desc: 'Mô tả',
            userInfo: 'TT tài khoản',
            status: 'Tình trạng',
            activated: 'Được hoạt động',
            deactivated: 'Dừng hoạt động',
            ip: 'Địa chỉ IP',
            phoneNumber: 'Số điện thoại',
            client: 'Khách',
            phoneHost: 'Tổng đài',
            inbound: 'Gọi vào',
            outbound: 'Gọi ra',
            gateway: 'Gateway',
            role: 'Quyền',
            owner: 'Chủ tài khoản',
            admin: 'Quản trị viên',
            viewer: 'Chỉ xem',
            sales: 'Sales',
            businessDevelopment: "Sales",
            accountManagement: 'Chăm sóc',
            am: 'Chăm sóc',
            accountant: 'Kế toán',
            agent: 'Tổng đài viên',
            country: 'Quốc gia',
            network: 'Nhà mạng',
            domain: 'Tên miền',
            today: "Hôm nay",
            yesterday: "Hôm qua",
            last7Days: "7 ngày qua",
            last30Days: "30 ngày qua",
            thisWeek: "Tuần này",
            lastWeek: "Tuần trước",
            thisMonth: "Tháng này",
            lastMonth: "Tháng trước",
            anytime: "Toàn bộ",
            time: 'Thời gian',
            all: "Tất cả",
            local: 'Nội bộ',
            finance: "Tài chính",
            mobile: "Điện thoại",
            cancel: "Huỷ",
            export: "Xuất dữ liệu",
            total: "Tổng",
            average: "Trung bình",
            group: "Nhóm",
            department: "Phòng",
            supervisor: "Trưởng nhóm",
            manager: "Trưởng phòng",
            operationsManager: "TP vận hành",
            employee: "Nhân viên",
            account: "Account",
            chooseMonth: 'Chọn tháng',
            selectAdminUser: 'Chọn nhân viên',
            detail: 'Chi tiết',
            createTime: 'Tạo lúc',
            updateTime: 'Cập nhật lúc',
            ext: 'Số nhánh',
            clientPackage: 'Đơn hàng cước trọn gói',
            creditBalance: 'Số dư',
            creditLimit: 'Hạn mức',
            note: 'Ghi chú',
            expireTime: 'Ngày hết hạn',
            activate: "Kích hoạt",
            lock: "Khoá",
            type: "Loại",
            isPackage: "Trọn gói",
            yes: "Có",
            no: "Không",
            agency: "Đại lý",
            chooseAgency: "Chọn đại lý",
            companyName: "Tên công ty",
            businessCategory: "Ngành nghề kinh doanh",
            unknown: "Chưa rõ",
            exportingData: "Đang xuất dữ liệu...",
            chooseBusinessCategory: "Chọn ngành nghề kinh doanh",
            category0: "Khác",
            category1: "Bảo hiểm",
            category2: "Bất động sản",
            category3: "Phân phối, Bán lẻ, Bán hàng online, Thương mại điện tử",
            category4: "Đầu tư tài chính (Ngân hàng, Cho vay, Chứng khoán)",
            category5: "Thuế, Tư vấn kế toán, Chữ ký số",
            category6: "Tích hợp hệ thống công nghệ, Phần mềm khác",
            category7: "Spa, Thẩm mỹ",
            category8: "Y tế, Bệnh viện, Phòng khám, Chăm sóc sức khoẻ",
            category9: "Giáo dục, Trung tâm dạy nghề, Trung tâm tiếng Anh, Tư vấn du học",
            clientTrialExtendRequest: "Yêu cầu gia hạn dùng thử",
            requestedBy: "Yêu cầu bởi",
            request: "Yêu cầu",
            waiting: "Đợi duyệt",
            approved: "Đã duyệt",
            rejected: "Bị từ chối",
            approve: "Duyệt",
            reject: "Từ chối",
            approveTime: "Duyệt lúc",
            approvedBy: "Người duyệt",
            rejectTime: "Từ chối lúc",
            rejectedBy: "Người từ chối",
            user: "Người dùng",
            inboundEnabled: "Được gọi vào",
            inboundDisabled: "Chặn vào",
            outboundEnabled: "Được gọi ra",
            outboundDisabled: "Chặn gọi ra",
            audioCallPrice: "Giá / phút gọi thoại",
            videoCallPrice: "Giá / phút gọi video",
            customerPrice: "Giá khách hàng",
            opportunityPrice: "Giá cơ hội bán hàng",
            ticketPrice: "Giá ticket",
            campaignContactPrice: "Giá liên hệ trong chiến dịch",
            price: "Giá",
            unlimitedUser: "Không giới hạn số lượng người dùng",
            noExpireTime: "Vô thời hạn",
            undefined: 'Không xác định',
            info: 'Thông tin',
            save: 'Lưu',
            isTrial: 'Đang dùng thử',
            exportNotice: 'Dữ liệu đang được tải xuống. Vui lòng chờ đợi trong giây lát...',
            notVerified: 'Chưa xác nhận',
            verified: 'Đã xác nhận',
            locked: 'Bị khoá',
            other: "Khác",
            more: "Xem thêm",
            selectClient: 'Chọn khách',
            sendTime: 'Gửi lúc',
            messageCampaigns: 'Chiến dịch gửi tin nhắn',
            template: 'Mẫu tin nhắn',
            sendErrorMsg: 'Thông báo lỗi',
            notYetSent: 'Chưa gửi',
            sent: 'Đã gửi',
            sentFail: 'Gửi thất bại',
            kycRequest: {
                title: 'Yêu cầu hồ sơ',
                create: 'Tạo yêu cầu hồ sơ',
                createdSuccess: 'Đã tạo yêu cầu — Account đã được thông báo qua Slack',
                kycSubmitted: 'Đã nộp KYC',
                kycMissing: 'Khách CHƯA nộp KYC',
                kycMissingNote: 'Khách hàng đã thấy thông báo trên callio-client. Đợi khách tự nộp KYC, hệ thống sẽ tự động chuyển trạng thái.',
                alreadyHasPending: 'Đã có yêu cầu đang xử lý',
                priorWarnTitle: 'Khách đã từng có yêu cầu hồ sơ trước đó',
                priorConfirm: 'Khách hàng này đã từng có yêu cầu hồ sơ trước đó. Vẫn tạo yêu cầu mới?',
                openExisting: 'Mở yêu cầu hiện có',
                warnNoDefaultAccount: 'Khách chưa gán Account, vui lòng chọn người xử lý',
                alreadyTaken: 'Yêu cầu đã được người khác tiếp nhận',
                cannotCancelTerminal: 'Không thể hủy — yêu cầu đã hoàn tất',
                cannotEditTerminal: 'Không thể sửa — yêu cầu đã hoàn tất',
                cannotReassignTerminal: 'Không thể đổi người xử lý — yêu cầu đã hoàn tất',
                invalidTransition: 'Chuyển trạng thái không hợp lệ',
                kycNotFound: 'Khách chưa nộp KYC — không thể đồng bộ',
                clientLabel: 'Khách hàng',
                noFilter: 'Không lọc',
                myRequests: 'Của tôi',
                stale: 'Quá 7 ngày',
                staleAlert: '{n} yêu cầu chưa xử lý quá 7 ngày',
                summary: 'Tổng quan',
                status: {
                    pending: 'Mới',
                    waitingKyc: 'Chờ KYC',
                    kycSubmitted: 'Đã nộp KYC',
                    inReview: 'Đang duyệt',
                    exported: 'Đã xuất HĐ',
                    canceled: 'Đã hủy',
                    all: 'Tất cả',
                },
                contractType: {
                    unspecified: 'Chưa xác định',
                    new: 'Hợp đồng mới',
                    renewal: 'Gia hạn',
                    upgrade: 'Nâng cấp gói',
                    changeEntity: 'Đổi pháp nhân',
                    other: 'Khác',
                },
                priority: {
                    normal: 'Bình thường',
                    high: 'Cao',
                    urgent: 'Khẩn',
                },
                action: {
                    take: 'Tiếp nhận',
                    reassign: 'Đổi người xử lý',
                    startReview: 'Bắt đầu duyệt',
                    exportContract: 'Xuất hợp đồng',
                    syncKyc: 'Đồng bộ KYC thủ công',
                    cancel: 'Hủy yêu cầu',
                    viewExistingKyc: 'Xem hồ sơ KYC',
                    backToList: 'Quay lại danh sách',
                },
                field: {
                    contractType: 'Loại hợp đồng',
                    priority: 'Ưu tiên',
                    assignedTo: 'Account xử lý',
                    requestedBy: 'Sales yêu cầu',
                    note: 'Ghi chú',
                    cancelReason: 'Lý do hủy',
                    contractNumber: 'Số hợp đồng',
                    createTime: 'Tạo lúc',
                    updateTime: 'Cập nhật',
                    exportTime: 'Xuất HĐ lúc',
                },
                section: {
                    info: 'Thông tin yêu cầu',
                    kycStatus: 'Trạng thái KYC khách',
                    contract: 'Hợp đồng',
                    history: 'Lịch sử',
                },
                history: {
                    bySystem: '(hệ thống)',
                },
            },
        }
    }
});
